import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';

// const DEMOS = [
//   { role:'super',    user:'superadmin', pass:'super123',  label:'Super Admin', icon:'⭐', color:'#f97316' },
//   { role:'admin',    user:'admin1',     pass:'admin123',  label:'Admin',       icon:'🛡️', color:'#3b82f6' },
//   { role:'employee', user:'emp1',       pass:'emp123',    label:'Employee',    icon:'👤', color:'#22c55e' },
// ];

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async e => {
    e.preventDefault();
    if (!username || !password) return toast.error('Enter credentials');
    setLoading(true);
    try {
      await login(username, password);
      toast.success('Welcome back!');
      navigate('/');
    } catch(err) {
      toast.error(err.response?.data?.message || 'Invalid credentials');
    } finally { setLoading(false); }
  };

  const pick = d => { setUsername(d.user); setPassword(d.pass); setActive(d.user); };

  return (
    <div style={{
      minHeight:'100vh', background:'var(--bg-deep)',
      display:'flex', alignItems:'stretch',
    }}>
      {/* Left panel */}
      <div style={{
        flex:'0 0 460px', background:'var(--bg-base)',
        borderRight:'1px solid var(--border-subtle)',
        display:'flex', flexDirection:'column', justifyContent:'center',
        padding:'60px 52px',
      }}>
        {/* Logo */}
        <div className="au" style={{ marginBottom:52 }}>
          <div style={{ display:'flex', alignItems:'center', gap:14, marginBottom:32 }}>
            <div style={{ width:46, height:46, background:'var(--brand-dim)', border:'1px solid var(--brand-glow)', borderRadius:12, display:'flex', alignItems:'center', justifyContent:'center', fontSize:22 }}>🔥</div>
            <div>
              <div style={{ fontSize:18, fontWeight:800, color:'var(--text-primary)', letterSpacing:'-.02em' }}>IndiaOil Gas</div>
              <div style={{ fontSize:11.5, color:'var(--text-muted)' }}>Booking Management System</div>
            </div>
          </div>
          <h1 style={{ fontSize:28, fontWeight:800, color:'var(--text-primary)', letterSpacing:'-.03em', lineHeight:1.2 }}>Sign in to your<br />account</h1>
          <p style={{ fontSize:14, color:'var(--text-muted)', marginTop:10 }}>Manage gas connections, bookings and customer alerts from one place.</p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="au d2">
          <div style={{ display:'flex', flexDirection:'column', gap:16 }}>
            <div>
              <label style={{ fontSize:12, fontWeight:600, color:'var(--text-secondary)', letterSpacing:'.02em', display:'block', marginBottom:6 }}>USERNAME</label>
              <input value={username} onChange={e=>setUsername(e.target.value)} autoFocus
                placeholder="Enter your username" className="form-input" style={{ fontSize:14 }} />
            </div>
            <div>
              <label style={{ fontSize:12, fontWeight:600, color:'var(--text-secondary)', letterSpacing:'.02em', display:'block', marginBottom:6 }}>PASSWORD</label>
              <input type="password" value={password} onChange={e=>setPassword(e.target.value)}
                placeholder="••••••••" className="form-input" style={{ fontSize:14 }} />
            </div>
            <button type="submit" disabled={loading} style={{
              marginTop:8, padding:'12px', background: loading ? 'var(--bg-elevated)' : 'var(--brand)',
              color: 'white', borderRadius:'var(--radius-md)', fontSize:14, fontWeight:700,
              border:'none', cursor: loading ? 'not-allowed' : 'pointer',
              boxShadow: loading ? 'none' : 'var(--shadow-brand)', transition:'var(--transition)',
              display:'flex', alignItems:'center', justifyContent:'center', gap:8
            }}>
              {loading ? (
                <><div style={{ width:16, height:16, border:'2px solid rgba(255,255,255,.3)', borderTopColor:'white', borderRadius:'50%', animation:'spin .7s linear infinite' }} /> Signing in...</>
              ) : 'Sign In →'}
            </button>
          </div>
        </form>

        {/* Demo accounts */}
        
      </div>

      {/* Right visual panel */}
      <div style={{
        flex:1, position:'relative', overflow:'hidden',
        background:'radial-gradient(ellipse at 30% 50%, rgba(249,115,22,0.08) 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, rgba(59,130,246,0.06) 0%, transparent 50%), var(--bg-deep)',
        display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:60,
      }}>
        {/* Grid background */}
        <div style={{
          position:'absolute', inset:0, opacity:0.04,
          backgroundImage:'linear-gradient(var(--text-primary) 1px, transparent 1px), linear-gradient(90deg, var(--text-primary) 1px, transparent 1px)',
          backgroundSize:'40px 40px',
        }} />

        {/* Feature cards */}
        <div style={{ position:'relative', zIndex:1, display:'flex', flexDirection:'column', gap:16, maxWidth:360 }}>
          {[
            { icon:'👥', title:'Customer Management', desc:'Full CRUD with Aadhar, phone, connection number tracking', color:'#f97316' },
            { icon:'📋', title:'Gas Booking System', desc:'Create, dispatch, and deliver cylinders with real-time tracking', color:'#3b82f6' },
            { icon:'🔔', title:'30-Day Rebook Alerts', desc:'Automated notifications for customers overdue for rebooking', color:'#22c55e' },
            { icon:'🔐', title:'Role & Permission Editor', desc:'Granular control — create and edit roles with custom permissions', color:'#a855f7' },
          ].map((f,i) => (
            <div key={i} className="au" style={{ animationDelay:`${i*0.08}s`,
              display:'flex', gap:14, padding:'16px 18px',
              background:'rgba(22,27,38,0.8)', backdropFilter:'blur(10px)',
              border:'1px solid var(--border-subtle)', borderRadius:'var(--radius-lg)',
            }}>
              <div style={{ width:36, height:36, background:`${f.color}14`, border:`1px solid ${f.color}28`, borderRadius:'var(--radius-md)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:16, flexShrink:0 }}>{f.icon}</div>
              <div>
                <div style={{ fontSize:13, fontWeight:700, color:'var(--text-primary)' }}>{f.title}</div>
                <div style={{ fontSize:12, color:'var(--text-muted)', marginTop:3, lineHeight:1.5 }}>{f.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
